import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import { ensureDefined } from '@e-socna/utils';

import { App } from './app/App';
import { AuthenticationContextProvider } from './contexts/AuthenticationContext';
import { PersistQueryClientProvider } from './components/PersistQueryClientProvider';
import { StrictMode } from './components/StrictMode';

import './init';

const { rootElement } = ensureDefined({
  rootElement: document.getElementById('root'),
});

const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <HelmetProvider context={{}}>
      <PersistQueryClientProvider>
        <AuthenticationContextProvider>
          <App />
        </AuthenticationContextProvider>
      </PersistQueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
);
